
import { Quest, QuestCategory } from '../../../types';

export const FIRST_RESPONDER_QUESTS: Quest[] = [
  {
    id: 1700,
    category: QuestCategory.SkillBuilder,
    title: 'First Aid: Minor Burns',
    questlineId: 'first-responder',
    isQuestlineStart: true,
    description: 'Knowing what to do in an emergency is a superpower. First, let\'s learn about minor burns.',
    details: 'Ask an adult to teach you the most important first step for a minor burn (like touching a hot pan). The answer is to put the burn under cool, running water for at least 10-20 minutes. Knowing this can make a big difference.'
  },
  {
    id: 1701,
    category: QuestCategory.SkillBuilder,
    title: 'First Aid: Cuts & Scrapes',
    questlineId: 'first-responder',
    prerequisiteQuestId: 1700,
    description: 'Next in your training: how to handle a simple cut or scrape.',
    details: 'With an adult, learn the three C\'s for cuts: Clean, Cover, and Care. Learn how to gently clean a wound with water, pat it dry, and apply a plaster or bandage correctly.'
  },
  {
    id: 1702,
    category: QuestCategory.SkillBuilder,
    title: 'First Aid: The Recovery Position',
    questlineId: 'first-responder',
    prerequisiteQuestId: 1701,
    description: 'If someone is unconscious but breathing, the recovery position can save their life. It\'s time to learn it.',
    details: 'This is a vital skill. Ask an adult to show you a video and then help you practice putting a willing volunteer (or a large teddy) into the recovery position safely.',
    youtubeId: 'p1A5005pE5g'
  },
  {
    id: 1703,
    category: QuestCategory.SkillBuilder,
    title: 'First Aid: Making the Call',
    questlineId: 'first-responder',
    prerequisiteQuestId: 1702,
    description: 'Knowing who to call and what to say is crucial. Let\'s practice making an emergency call.',
    details: 'With an adult, learn what information you need to give to emergency services (your location, the problem, who you are). Practice a mock call, staying calm and speaking clearly.'
  },
  {
    id: 1704,
    category: QuestCategory.SkillBuilder,
    title: 'First Aid: Know Your Kit',
    questlineId: 'first-responder',
    prerequisiteQuestId: 1703,
    description: 'A first responder knows their equipment. Let\'s investigate a first aid kit.',
    details: 'Go through a first aid kit with an adult. Your mission is to learn what at least five of the items are and what they are used for (e.g., antiseptic wipes, bandages, tape).'
  }
];
